/* eslint-disable max-lines */
/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

export const section1MedicalTypes = [
    MedicalTypeIds.Skin,
    MedicalTypeIds.SkinFaceToFace,
    MedicalTypeIds.Audiometry,
    MedicalTypeIds.RespiratorySensitiser,
    MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1,
    MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1,
    MedicalTypeIds.HAVS,
    MedicalTypeIds.HAVSFaceToFace,
    MedicalTypeIds.IonisingRadiation,
    MedicalTypeIds.IonisingRadiationFaceToFace,
    MedicalTypeIds.BiologicalMonitoring,
    MedicalTypeIds.OtherSurveillance,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.GroupOneDriving,
    MedicalTypeIds.GroupTwoDriving,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.NightWorker,
    MedicalTypeIds.LoneWorker,
    MedicalTypeIds.FoodHandlerQuestionsOnly,
    MedicalTypeIds.DSE,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
    MedicalTypeIds.ManualHandlingMSKQuestionnaire,
    MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
    MedicalTypeIds.AmzPitPupMedical,
    MedicalTypeIds.AmzPitPupHealthDeclaration,
    MedicalTypeIds.LAAWorker,
    MedicalTypeIds.FieldForce,
    MedicalTypeIds.SkinLevel1,
    MedicalTypeIds.SkinFaceToFaceLevel1,
    MedicalTypeIds.SkinAssessmentLevel2
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section1Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.PrivacyStatementConfirmation,
        questionText: "I can confirm that I have been provided with access to the <a href=\"https://tphealth.co.uk/privacy-statement\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Statement</a> which clearly explains in detail how, where and when my personal and health data will be processed",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.TeamPreventProcessPersonalInfoConfirmation,
        questionText: "In ticking this box, I understand that Optima Health will process my personal and Health related information for Occupational Health Purposes",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.InformationHeldSecurelyConfirmation,
        questionText: "I understand that my information will be held securely and if I wish to gain access to my medical information I can do so by requesting access in writing to Optima Health",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.FitnessToWorkProvidedToEmployerConfirmation,
        questionText: "I understand that information on my fitness to work will be provided to my employer",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.Title,
        questionText: "Title",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.FirstName,
        questionText: "First Name",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.LastName,
        questionText: "Last Name",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.Dob,
        questionText: "Date of Birth",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.Gender,
        questionText: "Gender",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique Id",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.JobTitle,
        questionText: "Job Role/Title",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.AddressLine1,
        questionText: "Address Line 1",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.AddressLine2,
        questionText: "Address Line 2",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.AddressLine3,
        questionText: "Address Line 3",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.City,
        questionText: "City",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.County,
        questionText: "County",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.Postcode,
        questionText: "Postcode",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.PersonalEmailAddress,
        questionText: "Email (Work or Personal)",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.MobilePhone,
        questionText: "Mobile Telephone",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.HomePhone,
        questionText: "Home Telephone",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.WorkPhone,
        questionText: "Work Telephone",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.OrgLevelId,
        questionText: "Org Level",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.OrgLevelName,
        questionText: "Org Level",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.ShiftPattern,
        questionText: "Shift Pattern",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.StandardHours,
        questionText: "Standard Hours per Week",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.ConsiderYourselfGoodHealth,
        questionText: "Do you consider yourself to be in good health?",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.HideEmployeeQuestionsAndRecordMedicalSeparately,
        questionText: "Hide employee questions and record medical history separately",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.MedicalHistoryDetails,
        questionText: "Medical history",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.ConsiderYourselfGoodHealthFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.ReceivingAnyFormMedicalTreatment,
        questionText: "Are you receiving any form of medical treatment?",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.ReceivingAnyFormMedicalTreatmentFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.TakingRegularMedication,
        questionText: "Are you taking any regular medication?",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.TakingRegularMedicationFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.SufferFromDisabilityImpairment,
        questionText: "Do you suffer from any form of disability / impairment?",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.SufferFromDisabilityImpairmentFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.AnythingForAttentionOfOccupationalHealthTeam,
        questionText: "Is there any other condition that you may wish to bring to the attention of the Occupational Health Team?",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.AnythingForAttentionOfOccupationalHealthTeamFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.StartDateOfEmployment,
        questionText: "Start Date of Employment",
        medicalTypes: section1MedicalTypes
    },
    {
        id: questionIds.CustomerId,
        questionText: "Customer",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.CustomerName,
        questionText: "Customer Name",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.WorkGroupId,
        questionText: "Work Group",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.WorkGroupName,
        questionText: "Work Groups",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.ReferredTitle,
        questionText: "Title",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.ReferredFirstName,
        questionText: "First Name",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.ReferredLastName,
        questionText: "Last Name",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.ReferredDob,
        questionText: "Date of Birth",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.ReferredGender,
        questionText: "Gender",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.OrgLevelId1,
        questionText: "Org Level",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.OrgLevelName1,
        questionText: "Org Level",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.OrgLevelId2,
        questionText: "Org Level 2",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.OrgLevelName2,
        questionText: "Org Level 2",
        medicalTypes: [
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    }
];
/* eslint-enable max-len */
/* eslint-enable max-lines */
